import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const FooterContainer = styled.footer`
  background-color: #0D1810;
  border-top: 2px solid var(--color-gold);
`;

export const FooterWrap = styled.div`
  padding: 56px 24px 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 1100px;
  margin: 0 auto;
`;

export const FooterLinksContainer = styled.div`
  display: flex;
  justify-content: center;

  @media screen and (max-width: 820px) {
    padding-top: 32px;
  }
`;

export const FooterLinksWrapper = styled.div`
  display: flex;

  @media screen and (max-width: 820px) {
    flex-direction: column;
  }
`;

export const FooterLinkItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 16px;
  text-align: left;
  width: 160px;
  box-sizing: border-box;
  color: var(--color-cream);

  @media screen and (max-width: 420px) {
    margin: 0;
    padding: 10px;
    width: 100%;
  }
`;

export const FooterLinkTitle = styled.h1`
  font-size: 11px;
  font-family: var(--font-body);
  font-weight: 700;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: var(--color-gold);
  margin-bottom: 16px;
`;

export const FooterLink = styled(Link)`
  color: var(--color-grey);
  text-decoration: none;
  margin-bottom: 0.5rem;
  font-size: 13px;
  font-family: var(--font-body);
  transition: color 0.25s ease;

  &:hover {
    color: var(--color-cream);
  }
`;

export const FooterExternalLink = styled.a`
  color: var(--color-grey);
  text-decoration: none;
  margin-bottom: 0.5rem;
  font-size: 13px;
  font-family: var(--font-body);
  transition: color 0.25s ease;

  &:hover {
    color: var(--color-cream);
  }
`;

export const SocialMedia = styled.section`
  max-width: 1000px;
  width: 100%;
`;

export const SocialMediaWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1100px;
  margin: 40px auto 0 auto;
  border-top: 1px solid rgba(184, 137, 42, 0.25);
  padding-top: 32px;

  @media screen and (max-width: 820px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const SocialLogo = styled(Link)`
  color: var(--color-cream);
  justify-self: start;
  cursor: pointer;
  text-decoration: none;
  font-size: 1.3rem;
  font-family: var(--font-heading);
  font-weight: 700;
  display: flex;
  align-items: center;
  margin-bottom: 0;
  letter-spacing: 0.5px;
`;

export const WebsiteRights = styled.small`
  color: var(--color-grey);
  font-size: 12px;
  font-family: var(--font-body);
  letter-spacing: 0.5px;
`;

export const SocialIcons = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  gap: 20px;
  width: auto;
`;

export const SocialIconLink = styled.a`
  color: var(--color-grey);
  font-size: 20px;
  transition: color 0.25s ease, transform 0.2s ease;

  &:hover {
    color: var(--color-gold-light);
    transform: translateY(-2px);
  }
`;